import {ActionType} from '../../../components/AutoForm/AutoFieldNew';
import {WizardField} from '../../../components/Wizard/QuestionWrapper';
import {ReviewDetailsFragment} from '../../../schema-types/ReviewDetailsFragment';
import {ContactAttribution} from '../../PrecursorSummaryPage/headerFields';
import getMeetingStatusBlock from './meetingStatus';
import getReviewTypeBlock from './reviewType';
import {wizardFieldsType} from '../../../components/Wizard/Wizard';
import {
  CommunicationMethod,
  ReviewAction,
  ReviewForEnum,
} from '../../../schema-types/globalTypes';
import {reviewActionFields} from './reviewAction';
import {AccountBasicFragment} from '../../../schema-types/AccountBasicFragment';
import {opportunityFields} from './opportunityValues';
import padFields from './padFields';
import {GetAllPadAdvisers_allPadAdvisers} from '../../../schema-types/GetAllPadAdvisers';

export type precursorAndHeaderFieldsType = wizardFieldsType & {
  reviewContact: ContactAttribution | string;
  isReviewFocused: 'Yes' | 'No';
  reviewFocus: string;
  name: string;
  meetingHappened: 'Yes' | 'No';
  pastMeetingDate: Date;
  meetingBooked: 'Yes' | 'No';
  attendeesPresent: boolean;
  meetingFormat: string;
  bookedMeetingDate: Date;
  bookedMeetingTime: Date;
  plannedMeetingDate: Date;
  meetingType: string;
  meetingLocation: string;
  opportunityValue: string;
  reviewAdviser?: string;
  reviewReason:
    | 'Ongoing client service'
    | 'Change of client circumstances'
    | 'Initial client meeting';
  status: string;
  dateBooked: Date;
  reviewAction: ReviewAction;
  declinedByClientDate: Date;
  declinedByClientMethod: CommunicationMethod;
  declineComment: string;
  previousCommunications: previousCommunicationsType;
  reviewFor?: ReviewForEnum;
  noResponseDate_1?: Date;
  noResponseMethod_1?: CommunicationMethod;
  noResponseDate_2?: Date;
  noResponseMethod_2?: CommunicationMethod;
  noResponseDate_3?: Date;
  noResponseMethod_3?: CommunicationMethod;
};

export type previousCommunicationsType = {
  contactDate: Date | null;
  contactMethod: CommunicationMethod | null;
}[];

export type headerFieldsType = precursorAndHeaderFieldsType & {
  primaryAtrValue: number;
  primaryAtrDate: Date;
  secondaryAtrValue?: number;
  secondaryAtrDate?: Date;
};

/** compose the precursor fields for creating a new review.
 * For editing isolated parts of the precursor, we can create a different set of fields as needed */
export const getCreateNewReviewFields = (
  reviewDetails: ReviewDetailsFragment | undefined,
  account: AccountBasicFragment | undefined,
  allPadAdvisers?: GetAllPadAdvisers_allPadAdvisers[]
): WizardField<precursorAndHeaderFieldsType>[] => {
  const fields: WizardField<precursorAndHeaderFieldsType>[] = [];
  if (account && reviewDetails) {
    // who is this for?
    if (account.secondaryContact) {
      fields.push({
        id: 'reviewContact',
        label: '',
        title: 'Review Contact',
        question: 'Who is the review for?',
        enabled: () => !!account?.secondaryContact,
        type: ActionType.buttonGroup,
        options: [
          {
            value: account?.primaryContact?.id,
            label: account?.primaryContact?.simplifiedName as string,
          },
          ...(account?.secondaryContact
            ? [
                {
                  value: account.secondaryContact.id as string,
                  label: account.secondaryContact.simplifiedName as string,
                },
                {
                  value: ContactAttribution.both,
                  label: `${account?.primaryContact?.simplifiedName} and ${account.secondaryContact.simplifiedName}`,
                },
              ]
            : []),
        ],
        initialValue: reviewDetails
          ? reviewDetails.contact?.id || ContactAttribution.both
          : ContactAttribution.both,
        requireSubmit: true,
      });
    }
    fields.push(...reviewActionFields(reviewDetails));

    fields.push(...getReviewTypeBlock(account, reviewDetails));
    fields.push(...getMeetingStatusBlock(account, reviewDetails));
    fields.push(...opportunityFields(reviewDetails, account));
    fields.push(...padFields(reviewDetails, account, allPadAdvisers));
  }
  return fields;
};
